export default "__VITE_ASSET__95ad3542__"